import { render, staticRenderFns } from "./CartTerms.vue?vue&type=template&id=4ef871c2&"
import script from "./CartTerms.vue?vue&type=script&lang=js&"
export * from "./CartTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports